/**
 * Display helper for displaying a number and unit with correct pluralization.
 * i.e. singular for 1, plural for everything else.
 *
 * @param n The amount
 * @param s The unit to be pluralized
 * @param plural Defaults to the string `s` followed by the character "s"
 */
export const pluralize = (n: number, s: string, plural?: string) => {
  // TODO I18N
  if (n !== 1) return plural ? `${n} ${plural}` : `${n} ${s}s`
  return `${n} ${s}`
}

export const formatPercent = (
  num: number,
  maximumFractionDigits = 0
): string => {
  return new Intl.NumberFormat(undefined, {
    style: "percent",
    maximumFractionDigits,
  }).format(num)
}

export const median = (arr: number[]): number | undefined => {
  if (!arr.length) return undefined;
  const sortedAsc = [...arr].sort((a, b) => a - b);
  const mid = Math.floor(sortedAsc.length / 2);
  const isEvenLength = sortedAsc.length % 2 === 0
  return isEvenLength ? ((sortedAsc[mid - 1] + sortedAsc[mid]) / 2) : sortedAsc[mid];
};



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/utils/number-helpers.ts